import React from 'react';

interface IconProps {
    height?: number;
    alt?: string;
}

const CrossIcon: React.FC<IconProps> = ({ height = 30, alt = "Cross" }) => {
    return <img src="/cross.png" alt={alt} style={{ height: `${height}px` }} />;
};

export default CrossIcon;
